import { Link } from "react-router-dom";

import { messages } from "@/config/messages";
import { sendAccountConfirmationEmail } from "@/server/actions/account-confirmation.action";
import { sendOrderConfirmationEmail } from "@/server/actions/order-confirmation.action";
import { Form } from "@/ui/form";
import cn from "@/utils/class-names";
import {
    NewsLetterFormSchema,
    newsLetterFormSchema,
} from "@/validators/newsletter.schema";
// import { StaticImport } from "next/dist/shared/lib/get-img-props";
import { useState } from "react";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";
import { Button, Input } from "rizzui";

export default function TemplatePreview({
    icon,
    title = "Newsletter!",
    // name,
    preview,
    className,
    description = "Feel free to preview it by clicking the button below.",
}: {
    icon: string;
    // name: string;
    title?: string;
    preview: string;
    className?: string;
    description?: string;
}) {
    return (
        <div
            className={cn(
                className,
                "rounded-2xl border border-gray-100 bg-white @container dark:bg-gray-50",
            )}
        >
            <div className="relative flex h-full w-full flex-col items-center justify-center p-6 @2xl:p-12 3xl:px-16 4xl:px-28">
                <div className="w-full max-w-[640px]">
                    <div className="relative mx-auto mb-6 h-20 w-20 @2xl:mb-8 @2xl:h-28 @2xl:w-28">
                        <img
                            src={icon}
                            alt="newsletter"
                            sizes="(max-width: 768px) 140px"
                        />
                    </div>
                    <div className="mb-8 text-center @2xl:mb-12">
                        <h2 className="mb-2 text-xl @2xl:mb-3 @2xl:text-2xl">
                            {title}
                        </h2>
                        <p className="mx-auto max-w-[45ch] text-sm leading-6 text-gray-500 @2xl:text-base">
                            {description}
                        </p>
                    </div>
                    <Link to={preview} target="_blank" className="block">
                        <Button as="span" size="lg" className="mx-auto w-full">
                            Preview
                        </Button>
                    </Link>
                    {/* <EmailForm template="accountConfirmation" /> */}
                </div>
            </div>
        </div>
    );
}

const initialValues = {
    email: "",
};

function EmailForm({ template }: { template: string }) {
    const [reset, setReset] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit: SubmitHandler<NewsLetterFormSchema> = async (data: any) => {
        console.log(data);

        setIsLoading(true);
        try {
            if (template === "accountConfirmation") {
                await sendAccountConfirmationEmail(data);
            }
            if (template === "orderConfirmation") {
                await sendOrderConfirmationEmail(data);
            }
            setReset(initialValues);
            setIsLoading(false);
            toast.success(messages.emailSentSuccessfully);
        } catch (error) {
            console.log("error", error);
            setIsLoading(false);
        }
    };
    return (
        <>
            <Form<NewsLetterFormSchema>
                validationSchema={newsLetterFormSchema}
                resetValues={reset}
                onSubmit={onSubmit}
                useFormProps={{
                    defaultValues: initialValues,
                }}
            >
                {({ register, formState: { errors } }) => (
                    <div className="relative">
                        <Input
                            size="xl"
                            placeholder="Enter your email"
                            inputClassName="w-full text-base pr-36"
                            {...register("email")}
                            error={errors.email?.message}
                        />
                        <Button
                            size="lg"
                            type="submit"
                            isLoading={isLoading}
                            className="absolute right-1 top-1 text-base font-medium"
                        >
                            Subscribe
                        </Button>
                    </div>
                )}
            </Form>
            <p className="mt-3 text-center text-sm font-medium text-gray-500 @2xl:mt-4 @2xl:text-base">
                Your email is safe with us, we don’t spam.
            </p>
        </>
    );
}
